<div class="card-footer py-3 bg-white">
  <div class="row align-items-center">
    <div class="col-12 col-sm-6 mb-3 mb-sm-0">
      <div class="table-footer-text d-flex justify-content-center justify-content-sm-start">Showing {{ paginationData.from }} to {{ paginationData.to }} of {{ paginationData.total }} entries</div>
    </div>
    <div class="col-12 col-sm-6">
      <ul class="table-footer-pagination d-flex justify-content-center justify-content-sm-end p-0 mb-0 list-unstyled" *ngIf="paginationData.last_page !== 1">
        <li class="page-item" [ngClass]="!paginationData.prev_page_url ? 'disabled':''">
          <a href="javascript:;" class="page-link" (click)="loadData(paginationData.prev_page_url)">← &nbsp; Prev</a>
        </li>
        <li class="page-item" [ngClass]="page_number == paginationData.current_page ? 'active':''" *ngFor="let page_number of childPagination">
          <a *ngIf="page_number !== ' ... '" href="javascript:;" (click)="loadData(paginationData.path+'?page='+page_number)" class="page-link">{{page_number}}</a>
          <a *ngIf="page_number === ' ... '" href="javascript:;" class="page-link">{{page_number}}</a>
        </li>
        <li class="page-item" [ngClass]="!paginationData.next_page_url ? 'disabled':''">
          <a href="javascript:;" class="page-link" (click)="loadData(paginationData.next_page_url)">Next &nbsp; →</a>
        </li>
      </ul>
    </div>
  </div>
</div>
